import React from 'react'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { authActions, filterActions } from '../../../redux/actions'
import { ReactComponent as LogoPickingReport } from '../../../../assets/icons/ic_picking_reporte.svg';
import { ReactComponent as LogoPickingDispatch } from '../../../../assets/icons/ic_picking_despacho.svg';
import { ReactComponent as LogoPickingUbication } from '../../../../assets/icons/ic_picking_ubication.svg';
import { ReactComponent as LogoManifestResend } from '../../../../assets/icons/ic_manifiesto_reenvio.svg';
import { ReactComponent as LogoManifestHistory } from '../../../../assets/icons/ic_manifiesto_historial.svg';
import { ReactComponent as LogoManifestEnterprises } from '../../../../assets/icons/ic_manifiesto_empresas.svg';

import acesssAPI from '../../../api/acesssAPI'

import './Sidebar.scss'

const Sidebar = ({ showMenu, menuRef }) => {
  const location = useLocation()
  const dispatch = useDispatch()
  const user = useSelector(state => state.authReducer.user)

  const logout = async () => {
    await acesssAPI.logout()
    dispatch(authActions.logout())
    dispatch(filterActions.cleanAll())
  }

  const Option = ({ text, redirectTo, icon }) => {
    // const active = location.pathname === redirectTo
    const active = location.pathname.includes(redirectTo)
    return (
      <Link className={`sidebar-option ${active && 'active'}`} to={redirectTo}>
        {
          icon
            ? icon
            : <img src={active ? require('../../../../assets/icons/plus_purple.svg') : require('../../../../assets/icons/plus_white.svg')}  alt='plus' />
        }
        <p>{text}</p>
      </Link>
    )
  }

  return (
    <div className={`sidebar-container ${showMenu ? 'show' : ''}`} ref={menuRef}>
      <div className='sidebar-title'>
        <h2>Hola,<span>{user ? user.fullname.split(' ')[0] : 'Admin'}!</span></h2>
        <img src={require('../../../../assets/images/colors_bar.svg')} alt='colors_bar'/>
      </div>
      <div className='sidebar-body'>
        <h2 className='sidebar-tag1'>Picking</h2>
        {/* <Option
          text='Carga de archivos'
          redirectTo='/carga'
        /> */}
        <Option
          text='Reporte de estados'
          redirectTo='/reporte-estados'
          icon={<LogoPickingReport />}
        />
        <Option
          text='Tipos de despachos'
          redirectTo='/tipos-despacho'
          icon={<LogoPickingDispatch />}
        />
        <Option
          text='Ubicación de items'
          redirectTo='/ubicacion-items'
          icon={<LogoPickingUbication />}
        />
        {/* <Option
          text='Re-asignación de CUDs'
          redirectTo='/reasignacion'
        /> */}
        <h2 className='sidebar-tag2'>Manifiestos</h2>
        <Option
          text='Reenvío de manifiestos'
          redirectTo='/reenvio-manifiestos'
          icon={<LogoManifestResend />}
        />
        <Option
          text='Historial de reportes'
          redirectTo='/historial-reportes'
          icon={<LogoManifestHistory />}
        />
        <Option
          text='Empresas'
          redirectTo='/empresas'
          icon={<LogoManifestEnterprises />}
        />
      </div>
      <div className='sidebar-footer'>
        <div className='logout' onClick={() => logout()}>
          <p>Cerrar sesión</p>
          <img src={require('../../../../assets/icons/logout.svg')} alt='logout'/>
        </div>
      </div>
    </div>
  )
}

export default Sidebar
